import { Dropdown } from './Dropdown';

export class VideoDropdown extends Dropdown {
  /**
   * @desc An array of html video selections.
   *
   * @type {HTML Nodes}
   */
  videoSelections;

  /**
   * @desc The video iframe node
   *
   * @type {HTML Nodes}
   */
  videoPlayer;

  /**
   * @desc Video selector selected class name.
   *
   * @type {String}
   */
  selectedClass = 'videos__video-active';

  /**
   * @desc Video selector hidden class name.
   *
   * @type {String}
   */
  hiddenClass = 'videos__video-hidden';

  /**
   * @class
   *
   * @extends {BaseClass}
   *
   * @desc Video filtering using terms from Drupal
   *
   * @param {HTMLNode} dropdownEl
   */
  constructor(identifier) {
    super(identifier);
    this.videoSelections = document.querySelectorAll(
      '.videos__video-selection'
    );
    this.videoPlayer = document.querySelector('iframe');
  }

  /**
   * @desc Change the video source
   * @param {HTML Object} dropdownOption
   */
  onChange = (dropdownOption) => {
    const term = dropdownOption.innerText;
    this.videoSelections.forEach((videoSelection) => {
      videoSelection.classList.remove(this.selectedClass);
      if (!this.matchTerms(term, videoSelection)) {
        videoSelection.classList.add(this.hiddenClass);
      } else {
        videoSelection.classList.remove(this.hiddenClass);
      }
    });
    this.selectTopOption();
  };

  /**
   * @desc Update the video plater attributes
   *
   * @param {string} attr
   *
   * @param {string} data
   */
  updatePlayerAttr = (attr, data) => {
    this.videoPlayer.setAttribute(attr, data);
  };

  /**
   * @desc Select the top option in the video player after a filter.
   */
  selectTopOption = () => {
    const selections = [...this.videoSelections];
    const activeSelections = selections.filter((videoSelection) => {
      return !videoSelection.classList.contains(this.hiddenClass);
    });
    const activeSelection = activeSelections[0];
    const videoSrc = activeSelection.getAttribute('data-video-src');
    const videoTitle = activeSelection.innerText;
    this.updatePlayerAttr('title', videoTitle);
    this.updatePlayerAttr('src', videoSrc);
    activeSelection.classList.add(this.selectedClass);
  };
}
